import React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import theme from '../../theme';

const styles = {
  ButtonContainer: {
    width: 200,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.textOn,
    margin: '0 auto',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  Button: {
    cursor: 'pointer',
    width: '100%',
    display: 'block',
    padding: '8px 12px',
    borderRadius: '4px',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
  },
};

export default injectSheet(styles)(
  ({ classes, style = {}, children, onClick, ...otherProps }) => {
    return (
      <div className={classNames(classes.ButtonContainer)} style={style}>
        <button
          className={classNames(classes.Button)}
          style={style}
          onClick={onClick}
          {...otherProps}
        >
          {children}
        </button>
      </div>
    );
  }
);
